export enum EntityType {
  Company = `Company`,
  Contact = `Contact`,
  Project = `Project`,
  None = `None`
}
